import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";
import axios from "axios";

const Dashboard = () => {
  const { wlletBalance, userDetails } = useContext(ProfileContext);
  const KycStatus = userDetails?.kycVerified;
  const [topMovers, setTopMovers] = useState([]);
  const navigate = useNavigate();

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
  };

  useEffect(() => {
    const fetchTopMovers = async () => {
      try {
        const response = await axios.get('https://min-api.cryptocompare.com/data/top/mktcapfull?limit=5&tsym=USD');
        const data = response?.data?.Data;
        setTopMovers(data);
      } catch (error) {
        console.error('Error fetching Binance data:', error);
      }
    };

    fetchTopMovers();
  }, []);

  const nextPageWallet = (chainName) => {
    navigate("/deposit", { state: chainName });
    navigate(KycStatus === 2 ? "/deposit" : "/update_kyc", { state: { chainName } });
  };

  return (
    <div className="wrapper dashboard_page">
      <div className="page-body d-flex align-items-stretch">
        <div className="page-content">
          <Sidebar />
          <div className="page_wrapper">
            <div className="container container-custom">
              <div className="row g-3">
                <div className="col-lg-12">
                  <div className="card bal_card_main">
                    <div className="card-body">
                      <div className="bal_row">
                        <div className="bal_col">
                          <span>Balance</span>
                          <em>${formatNumber(wlletBalance?.balance || 0)}</em>
                        </div>
                        <div className="bal_col">
                          <span>Equity</span>
                          <em>${formatNumber(wlletBalance?.balance || 0)}</em>
                        </div>
                      </div>
                      <div className="row g-3 mt-3">
                        <div className="col-6">
                          <Link to={KycStatus === 2 ? "/deposit" : "/update_kyc"} className="btn btn-primary btn-md w-100 btn-block">
                            DEPOSIT
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link to={KycStatus === 2 ? "/withdraw" : "/update_kyc"} className="btn btn-primary-light btn-md w-100 btn-block">
                            WITHDRAWAl
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="card bal_card_main">
                    <div className="card-body">
                      <h6 className="mb-3">Popular deposit methods</h6>
                      <div className="pm_list">
                        <div className="pm_card" onClick={() => nextPageWallet("BEP20")}>
                          <div className="d-flex align-items-center justify-content-start">
                            <img src="assets/images/ind_nb.svg" alt="" />
                            <span>BEP20 </span>
                          </div>
                        </div>
                        <div className="pm_card" onClick={() => nextPageWallet("BEP20")}>
                          <div className="d-flex align-items-center justify-content-start">
                            <img src="assets/images/ind_nb.svg" alt="" />
                            <span> ERC20 </span>
                          </div>
                        </div>
                        <div className="pm_card" onClick={() => nextPageWallet("BEP20")}>
                          <div className="d-flex align-items-center justify-content-start">
                            <img src="assets/images/ind_nb.svg" alt="" />
                            <span>TRC20 </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="card bal_card_main">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-3">Top daily movers</h6>
                      </div>
                      <div className="pr_list">
                        <div className="top-movers-container">
                          {topMovers?.map((mover, index) => (
                            <div className="pr_card success mb-2" key={index}>
                              <div className="td_div">
                                <div className="coin_name">
                                  <strong>{mover?.CoinInfo?.FullName}</strong>
                                </div>
                              </div>
                              <div className={`top-daily-movers__percent-block ${mover.DISPLAY?.USD?.CHANGEPCT24HOUR >= 0 ? 'text-success' : 'text-danger'}`}>
                                <img
                                  src={mover.DISPLAY?.USD?.CHANGEPCT24HOUR >= 0 ? 'assets/images/arrow-up.svg' : 'assets/images/arrow-down.svg'}
                                  alt=""
                                  className="top-daily-movers__percent-image"
                                />
                                <span className="top-daily-movers__percent-text">{(mover.DISPLAY?.USD?.PRICE)}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
